<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		viewBox="0 0 80 55"
		fill="none"
		class="overlapping-circles-icon"
		aria-hidden="true"
		focusable="false"
	>
		<path
			d="M34.1274 44.0541C34.8839 44.8909 35.696 45.677 36.5569 46.4066L35.5892 47.5478C34.6777 46.7753 33.8194 45.942 33.0184 45.0559L34.1274 44.0541Z"
			fill="currentColor"
		/>
		<path
			d="M46.9933 45.054C46.1927 45.9401 45.3346 46.7731 44.4234 47.5459L44.0346 47.0869L43.9401 46.9758L43.4567 46.4057C44.3172 45.6758 45.1281 44.8891 45.8843 44.0521L46.9933 45.054Z"
			fill="currentColor"
		/>
		<path
			d="M30.3072 38.4924C30.818 39.5021 31.3944 40.4737 32.0312 41.4004L30.7994 42.2463C30.125 41.2649 29.5142 40.2365 28.9731 39.1668L29.6397 38.8306L30.3072 38.4924Z"
			fill="currentColor"
		/>
		<path
			d="M51.0357 39.1648C50.4948 40.2345 49.8845 41.2629 49.2104 42.2444L47.9795 41.3985C48.6159 40.4718 49.193 39.501 49.7035 38.4914L51.0357 39.1648Z"
			fill="currentColor"
		/>
		<path
			d="M28.097 32.1218C28.3222 33.2367 28.6212 34.3253 28.9877 35.3817L28.2792 35.6263L28.2802 35.6272L27.5766 35.8709H27.5736C27.1853 34.7515 26.8689 33.5983 26.6303 32.4171L27.3631 32.2699L28.097 32.1218Z"
			fill="currentColor"
		/>
		<path
			d="M53.3775 32.4161C53.139 33.5973 52.8233 34.7505 52.4351 35.8699L51.022 35.3807C51.3884 34.3244 51.6867 33.2355 51.9118 32.1208L53.3775 32.4161Z"
			fill="currentColor"
		/>
		<path
			d="M26.9041 25.3371L27.6506 25.3868C27.6138 25.9456 27.5951 26.5099 27.5951 27.0786C27.5951 27.6472 27.6138 28.2115 27.6506 28.7704L26.9032 28.8191L26.9041 28.8201L26.1576 28.8678C26.1187 28.2765 26.0982 27.6798 26.0982 27.0786C26.0982 26.4771 26.1186 25.88 26.1576 25.2883L26.9041 25.3371Z"
			fill="currentColor"
		/>
		<path
			d="M53.8502 25.2883C53.8892 25.88 53.9106 26.477 53.9106 27.0786C53.9106 27.6798 53.8891 28.2765 53.8502 28.8678L53.1046 28.8201L52.3581 28.7704C52.395 28.2115 52.4137 27.6472 52.4137 27.0786C52.4137 26.51 52.395 25.9456 52.3581 25.3868L53.8502 25.2883Z"
			fill="currentColor"
		/>
		<path
			d="M52.4351 18.2872C52.8232 19.4063 53.139 20.5592 53.3775 21.74L51.9118 22.0363C51.6867 20.9217 51.3883 19.8336 51.022 18.7774L52.4351 18.2872Z"
			fill="currentColor"
		/>
		<path
			d="M28.9877 18.7755C28.6212 19.8318 28.3223 20.9205 28.097 22.0353L27.3631 21.8862L26.6303 21.7391C26.869 20.5579 27.1852 19.4046 27.5736 18.2853L28.9877 18.7755Z"
			fill="currentColor"
		/>
		<path
			d="M49.2104 11.9128C49.8845 12.8942 50.4947 13.9226 51.0357 14.9923L50.3711 15.3295L50.3701 15.3285L49.7035 15.6667C49.193 14.6571 48.6159 13.6863 47.9795 12.7597L49.2104 11.9128Z"
			fill="currentColor"
		/>
		<path
			d="M32.0322 12.7577C31.3954 13.6843 30.8181 14.6551 30.3072 15.6648L28.9741 14.9904C29.5152 13.9209 30.1251 12.8921 30.7994 11.9108L32.0322 12.7577Z"
			fill="currentColor"
		/>
		<path
			d="M44.4244 6.61128C45.3353 7.38385 46.1929 8.21727 46.9933 9.10318L46.5713 9.48617L45.8852 10.106C45.1291 9.26903 44.3172 8.48231 43.4567 7.75247L44.132 6.95724L44.4244 6.61128Z"
			fill="currentColor"
		/>
		<path
			d="M36.5579 7.75149C35.697 8.48103 34.8849 9.26728 34.1284 10.104L33.0184 9.10123C33.8195 8.21509 34.6784 7.38192 35.5902 6.60933L36.5579 7.75149Z"
			fill="currentColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M52.9205 0C67.8761 2.78508e-05 79.9998 12.1239 80 27.0795C79.9999 42.0352 67.8762 54.16 52.9205 54.1601C48.2423 54.1601 43.8411 52.9693 40 50.8798C36.1589 52.9692 31.7576 54.16 27.0795 54.1601C12.124 54.1599 0.000131679 42.0351 0 27.0795C0.000198038 12.124 12.124 0.000198026 27.0795 0C31.7573 6.1801e-05 36.1591 1.18906 40 3.27835C43.841 1.18908 48.2426 0 52.9205 0ZM52.9205 1.49689C48.7188 1.49689 44.7563 2.51089 41.2601 4.30454C41.3554 4.36404 41.4521 4.42128 41.5466 4.48191L40.7397 5.74199C40.4986 5.58735 40.2543 5.4364 40.0078 5.2898C39.7613 5.43619 39.5179 5.58756 39.2769 5.74199L38.469 4.48094C38.5606 4.42226 38.6525 4.36406 38.7448 4.30649C35.2474 2.51144 31.283 1.49695 27.0795 1.49689C12.9507 1.49709 1.49709 12.9507 1.49689 27.0795C1.49703 41.2084 12.9507 52.663 27.0795 52.6632C31.2829 52.6631 35.2465 51.6458 38.7438 49.8506C38.6513 49.7929 38.5588 49.735 38.467 49.6762L39.2759 48.4161C39.5168 48.5705 39.7605 48.721 40.0068 48.8673C40.2532 48.7208 40.4977 48.5707 40.7387 48.4161L41.5456 49.6752C41.4509 49.736 41.3536 49.7929 41.2581 49.8526C44.7549 51.647 48.7179 52.6632 52.9205 52.6632C67.0495 52.6631 78.503 41.2085 78.5031 27.0795C78.5029 12.9506 67.0494 1.49692 52.9205 1.49689Z"
			fill="currentColor"
		/>
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 80,
	height: 55
});
</script>
